export default __webpack_public_path__ + "static/media/MDV_C__0000_Layer-6.4d9e58df.png";